import { createContext, useState } from "react";
import $ from 'jquery'; 


export const RoutesContext = createContext();
export let routes = {
    current_page : '',
    homePage:{path:'/', active:''},
    services:{path:'/services', active: ''},
    service_1:{path:'/service-1', active:''},
    service_2:{path:'/service-2', active:''},
    service_3:{path:'/service-3', active:''},
    service_4:{path:'/service-4', active:''},
    service_5:{path:'/service-5', active:''},
    service_6:{path:'/service-6', active:''},
    about_company:{path:'/about-company', active:''},
    news_articles:{path:'/news-articles', active:''},
    gallery:{path:'/gallery', active:''},
    gallery_all:{path:'/gallery-all', active:''},
    contacts:{path:'/contacts', active:''},
    single_news:{path:'/single-news', active:''},
}

export function RoutesProvider({children}){
    
    function floating_section_loaded(){
    
        function isInViewport(element) {
          if(element){
          const rect = element.getBoundingClientRect();
        
          return ((rect.top >= 0 || rect.top < 0) &&  //Even if the element is located far above the viewport it will return true (It returns false only if the element is located below the viewport)
          rect.left >= 0 &&
          rect.bottom <= ((window.innerHeight + rect.height) || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)) ;
          }
        }
  
        const our_services_section = document.querySelector('.floating_section .our_services_section');
        const feedback_section = document.querySelector('.floating_section .feedback_section');
        const news_section = document.querySelector('.floating_section .news_section');
        const our_partners_section = document.querySelector('.floating_section .our_partners_section');
        const thanks_letters_section = document.querySelector('.floating_section .thanks_letters_section');
        const bottom_slider_section = document.querySelector('.floating_section .bottom_slider_section');
        
        
        
        const sections_array = [our_services_section, feedback_section, news_section, our_partners_section, thanks_letters_section, bottom_slider_section];

        let window_width = $(window).width(); 

        if(window_width > 992){
            $(document).on('scroll',()=>{
                let on_top = true;
            
                if(window.scrollY >= 100){
                    $('.main_slider_section').addClass('fade_out');
                    $('.main_slider_mobile').addClass('fade_out');
                    $('.about_us_banner_section').addClass('fade_out');
                    $('.floating_section').addClass('move_up');
                    on_top = false;
                
                } else {
                    $('.main_slider_section').removeClass('fade_out');
                    $('.main_slider_mobile').removeClass('fade_out');
                    $('.about_us_banner_section').removeClass('fade_out');
                    $('.floating_section').removeClass('move_up');
                    on_top = true;
                }
            

            
                sections_array.forEach((element)=>{
                    if(element && isInViewport(element)){
                        element.classList.add('active');
                    } else if(element){
                        element.classList.remove('active');  
                    } 
                });
            
            });
        } else if(window_width <= 992){

            sections_array.forEach((element)=>{
                if(element){
                    element.classList.add('active')
                }
            });

            if(window_width < 770){
                let current_with = $('.flip_card_container').width()
                $('.flip_card_container').css({'height': `${current_with - 130}px`});

                
                $(window).on('resize',(element)=>{
                    current_with = $('.flip_card_container').width();
                    $('.flip_card_container').css({'height': `${current_with - 130}px`});
                });
            }

        }
    
    } 

    function flip_card_resize(){
        if($(window).width() < 770){
          let current_with = $('.flip_card_container').width()
          $('.flip_card_container').css({'height': `${current_with - 130}px`});
    
          
          $(window).on('resize',(element)=>{
              current_with = $('.flip_card_container').width();
              $('.flip_card_container').css({'height': `${current_with - 130}px`});
          });
        }
      }


    


    let [status, setStatus] = useState(routes);

    function setCurrentPage(name){
        
        setStatus((prevData)=>{
            return {...prevData, [prevData.current_page] :{...prevData[prevData.current_page],active:''},current_page:name ,[name]:{...prevData[name], active:'active'}}
          });
         
    }

    $(window).on('load',()=>{       //Activating the current page when it is loaded for the first time
        for (let key in routes) {
            if (routes.hasOwnProperty(key)) {
                if(window.location.pathname === routes[key].path){     //Activating the button if the current path matches some of the routes
                    setCurrentPage(key);
                    break;
                }
            }
        }
    });

    return(         //values={} attr is the values that the context holds (and distributes to all its children)
    <RoutesContext.Provider value={{floating_section_loaded,routes, status, setCurrentPage, flip_card_resize}}>{children}</RoutesContext.Provider>  //{children} is the argument that receives components that were wrapped with this context
    );
}

export default RoutesContext;